"use strict";

var _toConsumableArray = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBasicWordForms = createBasicWordForms;
/**
 * Creates basic word forms for a given Arabic word.
 *
 * @param {string} word     The word for which to create basic word forms.
 *
 * @returns {Array}        Prefixed and de-prefixed variations of a word.
 */

function createBasicWordForms(word) {
  var prefixes = ["ل", "ب", "ك", "و", "ف", "س", "أ", "ال", "وب", "ول", "لل", "فس", "فب", "فل", "وس", "وال", "بال", "فال", "كال", "ولل", "وبال"];
  var forms = [];
  /*
   * Add prefixes to the input word. We always do this, since some words
   * beginning with a prefix-like letter might be exceptions where this is the
   * actual first letter of the word.
   */

  forms.push.apply(forms, _toConsumableArray(prefixes.map(function (prefix) {
    return prefix + word;
  })));
  var stemmedWord = "";
  /*
   * If a word starts with one of the prefixes, we strip it and create all possible
   * prefixed forms based on this stem.
   */

  for (var _i = 0, _prefixes = prefixes; _i < _prefixes.length; _i++) {
    var prefix = _prefixes[_i];

    if (word.startsWith(prefix)) {
      stemmedWord = word.slice(prefix.length);
    }
  }

  if (stemmedWord.length > 0) {
    forms.push(stemmedWord);
    forms.push.apply(forms, _toConsumableArray(prefixes.map(function (prefix) {
      return prefix + stemmedWord;
    })));
  }

  return forms;
}